import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FiMapPin, FiClock, FiMail, FiPhone, FiInstagram, FiFacebook, FiTwitter, FiYoutube, FiHeart } from "react-icons/fi";

class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer style={{ 
                    background: '#f45354',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
                        pointerEvents: 'none'
                    }}></div>

                    <div style={{ 
                        borderTop: '1px solid rgba(255,255,255,0.2)', 
                        padding: '1rem 0', 
                        textAlign: 'center',
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        position: 'relative'
                    }}>
                        <div className="container">
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '2rem',
                                flexWrap: 'wrap'
                            }}>
                                {/* <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <img 
                                        src="/assets/images/logo/logo.webp" 
                                        alt="พิพิธภัณฑ์สิงห์ท่า" 
                                        style={{
                                            height: '50px',
                                            width: 'auto',
                                            maxWidth: '150px',
                                            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                                            transition: 'transform 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                    />
                                </div> */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <p style={{ 
                                        color: 'rgba(255,255,255,0.9)', 
                                        fontSize: '1rem', 
                                        margin: 0,
                                        fontWeight: '400',
                                        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                                        lineHeight: '1.5'
                                    }}>
                                        พิพิธภัณฑ์สิงห์ท่า
                                        ถนนอุทัยรามฤทธิ์ ตำบลในเมือง อำเภอเมือง จังหวัดยโสธร 35000<br></br>
                                        © 2025 พิพิธภัณฑ์สิงห์ท่า (Singha Tha Museum). สงวนลิขสิทธิ์ทุกประการ.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}

export default Footer;